import CloseIcon from '../../../assets/icons/close.svg?react';
import { useUpdateNotificationRule, useNotificationTargetList } from '../../../hooks/queries/logQueries';
import { useState, useEffect } from 'react';
import AlertSetUpTargetListItem from './AlertSetUpTargetListItem';
import { useAuthContext } from '../../../contexts/AuthContext';
import Pagination from '../../../components/Pagination/Pagination';


const AlertSetUpTargetEditModal = ({ onClose, target,  onSubmit }) => {
  
  const updateNotificationRule = useUpdateNotificationRule();
  const { user } = useAuthContext();

  // NotificationTargets가 객체 배열일 수 있으므로 ID만 추출
  const getNotificationTargetIds = (targets) => {
    if (!targets || !Array.isArray(targets)) return [];
    return targets
      .map(target => {
        if (typeof target === 'string') return target;
        return target?.NotificationTargetSysId || target?.id;
      })
      .filter(id => id != null); // null, undefined 제거
  };

  const [initialNotificationTargets, setInitialNotificationTargets] = useState(getNotificationTargetIds(target));
  const [notificationTargets, setNotificationTargets] = useState(getNotificationTargetIds(target));

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const { data: notiTargetList, isLoading: isLoadingNotiTargetList, refetch: refetchNotiTargetList } = useNotificationTargetList({
    Page: currentPage,
    PageSize: pageSize,
  });
  const totalPages = Math.ceil(notiTargetList?.Total / pageSize);

  // useEffect(() => {
  //   refetchUsers({
  //     page: currentPage,
  //     pageSize: pageSize,
  //   });
  // }, [currentPage]);

  const handleReset = () => {
    setNotificationTargets(initialNotificationTargets);
  };


  const handleToggleNotificationTarget = (notiTargetSysId) => {
    setNotificationTargets(prev => {
      if (prev.includes(notiTargetSysId)) {
        return prev.filter(id => id !== notiTargetSysId);
      }
      return [...prev, notiTargetSysId];
    });
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  
  return (
    <div className="modal-background">
      <div className="modal-container alert-setup-target-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>알림 대상 수정</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content flex flex-col gap-10">
          <p className="text-b2-400 text-gray-600">알림 대상을 선택해주세요.</p>
          <table className="primary-table w-full">
            <thead>
              <tr>
                <th width="40px"></th>
                <th>대상타입</th>
                <th>대상값</th>
              </tr>
            </thead>
            <tbody>
              {notiTargetList?.Items?.map((notiTarget) => (
                <AlertSetUpTargetListItem key={notiTarget.NotificationTargetSysId} notiTarget={notiTarget} notificationTargets={notificationTargets} handleToggleNotificationTarget={handleToggleNotificationTarget} />
              ))}
            </tbody>
          </table>
          <div className="flex justify-center mb-10">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              size="small"
            />
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn big-btn btn-style-5" onClick={handleReset}>
            초기화
          </button>
          <button className="btn big-btn btn-primary" onClick={()=>onSubmit(notificationTargets)}>
            적용
          </button>
        </div>
      </div>
    </div>
  )
}

export default AlertSetUpTargetEditModal